import ApiBase from './api-base'

class Review extends ApiBase {
  async create ({
    title = '',
    text = '',
    name = '',
    rating = 0,
    variantId = 0,
    distributionConsent = false,
    authorFingerPrint = {}
  }) {
    const url = '/v2/reviews'

    const { data } = await this.client.post(url, {
      review: {
        title,
        text,
        name,
        rating,
        variant_id: variantId,
        distribution_consent: distributionConsent,
        author_finger_print: authorFingerPrint
      }
    })

    return data
  }

  async put ({
    reviewId,
    title = '',
    text = '',
    name = '',
    rating = 0,
    variantId = 0,
    distributionConsent = false,
    authorFingerPrint = {}
  }) {
    const url = `/v2/reviews/${reviewId}`

    const { data } = await this.client.put(url, {
      review: {
        title,
        text,
        name,
        rating,
        variant_id: variantId,
        distribution_consent: distributionConsent,
        author_finger_print: authorFingerPrint
      }
    })

    return data
  }
}

export default Review
